//------------------------------------------------
// Field formatter
// This will convert the text field to an option field
// For example: if the field is a dropdown, it will convert the text to an option
// This is useful for the CMS field editors
// Example: if the field offers options,
// the text value "Option" will be converted to an option object like
//  { value: 'option', name: 'Option' }
// When exporting the data, the value will be converted back to the text
//  'Option'
//------------------------------------------------
import { isInternalType } from "../internal-type"

export default {
  type: "Text",
  preFormat: (fieldValues, Type) => {
    // Don't change fields inside internally used types
    if (isInternalType(Type)) return fieldValues
    // If Type is not provided or has no fields, return as-is
    if (!Type || !Type.fields) return fieldValues
    //No values, return
    if (!fieldValues) return fieldValues
    //each item has the following fields
    const fieldTypes = Type.fields
    for (const field of fieldTypes) {
      if (!field) continue

      // Handle both string type and object type {value: "Text", name: "Text"}
      const fieldType = typeof field.type === "object" && field.type?.value
        ? field.type.value
        : field.type

      if (fieldType !== "Text") continue
      if (!field.options || !field.options.length) continue
      if (!fieldValues[field.id]) continue

      const itemValue = fieldValues[field.id]
      //convert text to option
      //for all other fields, we just save the value
      if (field.options && typeof itemValue === "string") {
        fieldValues[field.id] = { value: itemValue, name: itemValue }
      }
    }

    return fieldValues
  },
  postFormat: (fieldValues, Type) => {
    // Don't change fields inside internally used types
    if (isInternalType(Type)) return fieldValues
    // If Type is not provided or has no fields, return as-is
    if (!Type || !Type.fields) return fieldValues
    //No values, return
    if (!fieldValues) return fieldValues

    //each item has the following fields
    const fieldTypes = Type.fields

    for (const field of fieldTypes) {
      if (!field) continue

      // Handle both string type and object type {value: "Text", name: "Text"}
      const fieldType = typeof field.type === "object" && field.type?.value
        ? field.type.value
        : field.type

      if (fieldType !== "Text") {
        continue
      }
      if (!fieldValues[field.id]) {
        continue
      }

      // Only process fields that have options defined
      const fieldValue = fieldValues[field.id]
      const hasOptions = field.options && field.options.length

      if (!hasOptions) {
        continue
      }

      const itemValue = fieldValues[field.id]

      //convert option to text
      if (Array.isArray(itemValue)) {
        // Handle array of options
        const firstItem = itemValue[0]
        fieldValues[field.id] = (firstItem && typeof firstItem === 'object' && firstItem.value)
          ? firstItem.value
          : firstItem
      } else if (itemValue && typeof itemValue === 'object' && itemValue.value) {
        // Handle single option object - extract the value
        fieldValues[field.id] = itemValue.value
      }
      // If itemValue is already a string, leave it as-is (no else clause needed)
    }

    // Loop through all fields in the Type.fields
    return fieldValues
  },
}
